import Vue from 'vue';
import Tv from './Tv.vue';
import store from './store';
import './plugins';
import './registerServiceWorker';

// Vue.config.performance = true;
Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(Tv)
}).$mount('#tv');
